// export const server = `https://staging-api.aspeed.ariba.sg/api/`
// export const server = `https://api.aspeed.com.sg/api/` //production
export const server = `https://ppapi.aspeed.com.sg/api/` // student
// export const server = `http://aspeed.localhost/api/` // hx local
// export const server = `http://192.168.0.5/aspeed-api/public/api/`
